import React from 'react'
import { defaultTo } from 'ramda'
import defaultAppIconSrc from './defaultAppIcon.svg'
import cx from 'classnames'
import './style.css'

const orDefaultIcon = (iconUrl) => defaultTo(defaultAppIconSrc)(iconUrl)
const orDefaultDescription = (description) => defaultTo('Add a short description...')(description)


const AppPreviewTile = ({ iconUrl, name, description, isIconUpdating }) => (
  <div className="app-preview-tile-wrapper">
    <span className="app-preview-tile-wrapper-title">
      App Preview
    </span>
    <div className="app-preview-tile">
      <img
        src={orDefaultIcon(iconUrl)}
        alt="logo"
        className={cx('app-preview-tile-icon', {
          'app-preview-tile-icon-updating': isIconUpdating
        })}
      />
      <span className="app-preview-tile-name">
        {name}
      </span>
      <p className="app-preview-tile-description">
        {orDefaultDescription(description)}
      </p>
      <span className="app-preview-tile-details">
        See Details
      </span>
    </div>
  </div>
)

export default AppPreviewTile
